import { z } from "zod";

export type StudyType = "asset" | "scene" | "video";

export interface StudyPartial {
  name: string;
  isArchived?: boolean;
  route: string;
  contextPackIds?: string[];
}

export interface Study extends StudyPartial {
  id: string;
  project: {
    id: string;
    name: string;
  };
  useCase: {
    id: string;
    name: string;
  };
  type?: StudyType;
  assetCount: number;
  contextPackIds: string[];
  createdAt: string;
  updatedAt: string;
  username: string;
}
export interface HandleSaveArchiveValues {
  isArchived: boolean;
}

/* Schema */
export const updateStudySchema = z
  .object({
    name: z
      .string()
      .min(1, "Study name is required")
      .max(255, "Study name must be 255 characters or less")
      .refine((val) => val.trim().length > 0, "Study name is required"),
    useCaseId: z.string().optional(),
    useCaseName: z.string().optional(),
    route: z.string().optional(),
    type: z.enum(["asset", "scene", "video"]).optional(),
  })
  .refine((data) => data.useCaseName !== "" && data.useCaseId !== "", {
    message: "Please go back and select a use case",
    path: ["useCaseId"],
  });

export const archiveStudySchema = z.object({
  isArchived: z.boolean(),
});
